import utils from '../../lib/utils';

export const H5PageLink = {
    inviteSendCourse: `https://www.putaoabc.com/onlinepages/activity/invite_friend_app/invite_message.html?v=${utils.getRandom()}`,
    buyCourse: `https://www.putaoabc.com/onlinepages/activity/course_buy/?from_buy=pc&v=${utils.getRandom()}`
}


// WEBPACK FOOTER //
// ./src/static/json/page-link.js